export default <T extends Event>(element: EventTarget, type: string, listener: (e: T) => void): void => {
    const _fn = (e: T) => {
        // @ts-ignore
        element.removeEventListener(type, _fn);
        listener(e);
    };
    // @ts-ignore
    element.addEventListener(type, _fn);
};
